import HrmApi from './HrmApi'
import * as config from '../../../config.js'
var Api = new HrmApi({
  url: config.API_ROOT
})

export default Api
